import { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { DEFAULT_THIS_YEAR_PERIOD } from '@/helpers/date';
import { ReportDownloadModal } from '@/modals/ReportDownloadModal';
import { ReportReferenceModal } from '@/modals/ReportReferenceModal';
import { Filters } from './components/Filters';
import { DataView } from './components/DataView';
import s from './index.module.scss';

const DEFAULT_PARAMS = {
  page: 1,
  range: DEFAULT_THIS_YEAR_PERIOD,
  operation_types: [],
  grouping: true,
};

const CashMovementsPage = () => {
  const { type: accountType } = useOutletContext();
  const [params, setParams] = useState(DEFAULT_PARAMS);

  useEffect(() => {
    setParams(DEFAULT_PARAMS);
  }, [accountType]);

  return (
    <div className={s.page}>
      <Filters params={params} setParams={setParams} />
      <DataView params={params} setParams={setParams} />
      <ReportDownloadModal type="cash_movements" params={params} />
      <ReportReferenceModal accountType={accountType} />
    </div>
  );
};

export default CashMovementsPage;
